import React from "react";


class Logout extends React.Component {
    componentDidMount(){
        localStorage.clear();
        window.location.replace("/login");
    }
    render(){
        return(
            <div></div>
        )
    }

}

export default Logout;